import React from 'react';

const SearchContainer = ({ searchTerm, onSearchChange }) => {
    return (
        <div className="search-container">
            <input 
                type="text" 
                className="search-input" 
                value={searchTerm}
                onChange={onSearchChange}
                placeholder="Search courses by name or description..."
            />
        </div>
    );
};

export default SearchContainer;
